import { render, staticRenderFns } from "./ComponenteHistorial.vue?vue&type=template&id=c504a6d4&scoped=true&"
import script from "./ComponenteHistorial.vue?vue&type=script&lang=js&"
export * from "./ComponenteHistorial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c504a6d4",
  null
  
)

export default component.exports